import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=b8c648a0&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=b8c648a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c648a0",
  null
  
)

export default component.exports